import { Square } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { MealCreditFormProvider } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditFormProvider/MealCreditFormProvider';
import { IMealCredit } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';
import { MealCreditDataProvider } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';
import { pushError, pushSuccess } from 'src/utilities/notifications';
import { MealCreditForm } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditForm';

export interface MealCreditEditFormSectionProps {
  corpId: string;
  mealCredit: IMealCredit;
  fetchMealCredit: () => Promise<void>;
}

export function MealCreditEditFormSection({
  corpId,
  mealCredit,
  fetchMealCredit,
}: MealCreditEditFormSectionProps): JSX.Element {
  const { push } = useHistory();

  return (
    <Square inset="lg" bg="globals.white" dimension="2">
      <MealCreditFormProvider>
        <MealCreditDataProvider mealCredit={mealCredit}>
          <MealCreditForm
            onUpdateMealCreditSuccess={async (): Promise<void> => {
              pushSuccess('Your meal credit was updated');
              await fetchMealCredit();
              push(
                `/corporate/enterprise/${corpId}/meal-credits/${mealCredit.id}/details`
              );
            }}
            onUpdateMealCreditError={async (): Promise<void> => {
              pushError('Your meal credit was not updated. Try again.');
            }}
          />
        </MealCreditDataProvider>
      </MealCreditFormProvider>
    </Square>
  );
}
